
import searchInput from '@/components/search-input';
import divSpan from '@/components/DivSpan';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import fileUpload from '@/components/file-upload';
import manualSearch from '@/components/manual-search';
export default {
name: "qualificatiion-expires-query",
components:{
searchInput,
divSpan,
Popup,
manualSearch,
fileUpload
},
directives: {
TransferDom
},
data(){
return{
show: true,
quicklySearchList:[{name:'全部',code:null},{name:'已确认',code:"1"},{name:'未确认',code:"0"}],
pageRules: {
direction: "DESC",
fromClientType: "pc",
number: 0,
property: "createdDate",
size: 10,
rules: [],
specialConditions: [],
workflowSearchBean: {}
},
wrapperHeight:0,
tabIndex:1,
allLoaded:false,
contractList:[],
qualDetail:{},
showDetail:false,
userType:'1',
value:''
}
},
methods:{
goDetail(qual){
if(qual){
this.qualDetail = qual;
this.showDetail = true;
}
},
quicklySearchChange(e){
if(!this.pageRules.rules){
this.pageRules.rules = [];
}
this.pageRules.rules = this.pageRules.rules.filter(item => item.field !== 'status');
let rules;
if(e.code){
rules = {field:'status',option:'IN',values:[e.code]}
}
if(rules){
this.pageRules.rules.push(rules);
}
this.pageRules.number = 0;
this.getList();
},
getRules(e){
if(!this.pageRules.rules){
this.pageRules.rules = [];
}
this.pageRules.rules = this.pageRules.rules.filter(item => item.field === 'status' || item.field === 'supplier.supplierCode-supplier.supplierName');
this.pageRules.number = 0;
if(e && e.length){
e.forEach(val=>{
if(val.code && val.code.length){
this.pageRules.rules.push({field:val.name,values:val.code,option:val.option});
}
})
}
this.getList();
},
getList(){
this.$loadingShow();
this.$post('api/sup-qual/page',this.pageRules).then(data=>{
this.$loadingHide();
if(this.pageRules.number==0){
this.contractList=data.content;
}else {
this.contractList=this.contractList.concat(data.content);
}
},()=>{    this.$loadingHide();})
},
closeQual(){
this.showDetail = false;
},
qualChange(val){
if(val === '1'){
this.$post('api/sup-qual/batch-check',[this.qualDetail.id]).then(val=>{
this.$vux.toast.text('确认成功');
this.pageRules.number=0;
this.getList();
})
}else{
this.$post('api/sup-qual/batch-uncheck',[this.qualDetail.id]).then(val=>{
this.$vux.toast.text('取消确认成功');
this.pageRules.number=0;
this.getList();
})
}
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.pageRules.number=0;
this.getList();
this.$refs.loadmore.onTopLoaded();
},
loadBottom(){
this.pageRules.number=this.pageRules.number + 1;
this.getList();
this.$refs.loadmore.onBottomLoaded();
},
clear(){
this.value = '';
this.searchList();
},
searchList(){
this.pageRules.rules = this.pageRules.rules.filter(item => item.field !== 'supplier.supplierCode-supplier.supplierName');
this.pageRules.number = 0;
if(this.value){
this.pageRules.rules.push({field:'supplier.supplierCode-supplier.supplierName',option:"LIKE_ANYWHERE",values:[this.value]});
}
this.getList();
}
},
mounted(){
this.init();
this.getList();
this.$get('api/person/current').then((data) => {
this.userType = data.userType;
})
},

}



// WEBPACK FOOTER //
// ./src/page/supplier-qualification-expires/qualification-expires-query.vue